import { IMPLICIT_GENDER, ageFromDob } from "../wizardUtils";
import { Field } from "../formHelpers";

const GENDER_OPTIONS = [
  { key: "male", label: "Male" },
  { key: "female", label: "Female" },
  { key: "other", label: "Other" },
];

export default function PersonalFieldsSection({ mKey, ins, errors, setIns }) {
  const implicit = IMPLICIT_GENDER[mKey];
  const showGenderPicker = !implicit;
  const age = ageFromDob(ins.dob);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      <Field label="Full Name" testId={`name-${mKey}`} error={errors[`${mKey}-name`]}>
        <input
          type="text"
          value={ins.name || ""}
          onChange={(e) => setIns(mKey, "name", e.target.value)}
          className={`form-input ${errors[`${mKey}-name`] ? "error" : ""}`}
          placeholder="Full name"
          data-testid={`input-name-${mKey}`}
        />
      </Field>
      <Field
        label="Date of Birth"
        testId={`dob-${mKey}`}
        error={errors[`${mKey}-dob`]}
        help={age !== null ? `Age: ${age} years` : "YYYY-MM-DD"}
      >
        <input
          type="date"
          value={ins.dob || ""}
          onChange={(e) => setIns(mKey, "dob", e.target.value)}
          max={new Date().toISOString().split("T")[0]}
          className={`form-input ${errors[`${mKey}-dob`] ? "error" : ""}`}
          data-testid={`input-dob-${mKey}`}
        />
      </Field>
      {showGenderPicker && (
        <Field label="Gender" testId={`gender-${mKey}`} error={errors[`${mKey}-gender`]}>
          <div className="flex gap-2">
            {GENDER_OPTIONS.map((g) => (
              <button
                key={g.key}
                type="button"
                onClick={() => setIns(mKey, "gender", g.key)}
                className={`radio-card ${ins.gender === g.key ? "active" : ""}`}
                data-testid={`gender-${mKey}-${g.key}`}
              >
                {g.label}
              </button>
            ))}
          </div>
        </Field>
      )}
      <Field label="Height (cm)" testId={`height-${mKey}`} error={errors[`${mKey}-height`]}>
        <input
          type="number"
          inputMode="numeric"
          min="30"
          max="250"
          value={ins.heightCm ?? ""}
          onChange={(e) => {
            const v = e.target.value.replace(/\D/g, "");
            setIns(mKey, "heightCm", v === "" ? "" : Number(v));
          }}
          className={`form-input ${errors[`${mKey}-height`] ? "error" : ""}`}
          placeholder="e.g. 172"
          data-testid={`input-height-${mKey}`}
        />
      </Field>
      <Field label="Weight (kg)" testId={`weight-${mKey}`} error={errors[`${mKey}-weight`]}>
        <input
          type="number"
          inputMode="numeric"
          min="2"
          max="300"
          value={ins.weightKg ?? ""}
          onChange={(e) => {
            const v = e.target.value.replace(/\D/g, "");
            setIns(mKey, "weightKg", v === "" ? "" : Number(v));
          }}
          className={`form-input ${errors[`${mKey}-weight`] ? "error" : ""}`}
          placeholder="e.g. 68"
          data-testid={`input-weight-${mKey}`}
        />
      </Field>
    </div>
  );
}
